import SubHeaderBox from "../../components/SubHeaderBox";
import { useTranslation } from "react-i18next";
import WasteGeneratedTable from "./Table";
import { ShowHideTable } from "../../components/ShowHideTable";
import "./index.css";
import wasteGenIcon from "../../../../../assets/design-revamp-company/category-icons/waste_generated_icon.svg";
import { usePDFShowHide } from "../../../../../hooks/usePDFShowHide";
import TableLoadingWrapper from "../../../../../components/TableLoadingWrapper";
const WasteGeneratedContents = ({ productId }) => {
  const { t } = useTranslation();
  const [showTable, setShowTable, isPDFMode] = usePDFShowHide(false, {
    pdfDelay: 5000,
    forceShowInPDF: true,
  });
  const shouldShowTable = isPDFMode || showTable;
  return (
    <div className="processing-sold-contents">
      <div style={{ display: "flex", alignItems: "center" }}>
        <SubHeaderBox
          subTitle={t("WASTE_GEN_TITLE")}
          subDescription={t("WASTE_GEN_DESC")}
          isNormal={true}
          number={"15.1C"}
          icon={wasteGenIcon}
        />
      </div>
      {shouldShowTable && (
        <TableLoadingWrapper
          tableId={`prod-wastegenerated-${productId}`}
          minLoadTime={3000}
          maxLoadTime={20000}
        >
          <WasteGeneratedTable productId={productId} />
        </TableLoadingWrapper>
      )}
      <ShowHideTable showTable={showTable} setShowTable={setShowTable} />
    </div>
  );
};

export default WasteGeneratedContents;
